import { Fragment, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import equal from "fast-deep-equal";
import FleetWebApi from "../Api/FleetWebApi";
import OwnerResultsDetails from "./OwnerResultDetails";
import { useNavigate } from "react-router";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

const DomainOwnerResult = (props) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [searchResultDetails, setSearchResultDetails] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [domain, setDomain] = useState(props.domain);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (!equal(props.domain, domain)) {
      setIsLoaded(false);
      setDomain(props.domain);
      getDomainOwnerSearch(props.domain);
    }
  }, [props, domain]); // re-run the effect when `props` or `domain` changes

  useEffect(() => {
    getDomainOwnerSearch(props.domain);
  }, []); // run the effect only on mount
  useEffect(() => {
    if (
      searchResultDetails &&
      searchResultDetails.response &&
      searchResultDetails.response.length === 1
    ) {
      navigate("/domain/" + searchResultDetails.response[0].user_id);
    }
  }, [searchResultDetails, navigate]);
  const getDomainOwnerSearch = (domain, searchResultDetails) => {
    FleetWebApi.getDomainOwnerSearch(domain).then(
      (result) => {
        setSearchResultDetails(result);
        setIsLoaded(true);
      },
      (error) => {
        setIsLoaded(true);
        setError(error);
      }
    );
  };

  let searchResultsContainer;
  if (error) {
    searchResultsContainer = <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    searchResultsContainer = (
      <div>
        <CircularProgress color="secondary" />
      </div>
    );
  } else {
    if (searchResultDetails.response.length === 1) {
      return null;
    } else {
      searchResultsContainer = (
        <OwnerResultsDetails
          searchResultDetails={searchResultDetails.response}
          lookedFor={props.domain}
        />
      );
    }
  }

  return (
    <Fragment>
      <h2>Users affiliated with owner ID: {props.domain}</h2>

      <AppBar position="static" style={{ background: "#2E3B55" }}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="secondary"
        >
          <Tab label="Search Results" />
        </Tabs>
      </AppBar>

      <TabPanel value={tabValue} index={0}>
        <Grid>{searchResultsContainer}</Grid>
      </TabPanel>
    </Fragment>
  );
};

export default DomainOwnerResult;
